export default __webpack_public_path__ + "static/media/li.813c4b04.svg";